<template>
    <div class="active_side_menu" :class="{'active__menu': menu}">
        <div class=controlle-page-header :class="{'active__menu': menu}">

          <div class="logo__container">
            <img src="./../../assets/menu.svg" class="menu-icon" @click="toggleMenu(null)" />
            <img class="adway-controlle-header" src="./../../assets/header.png" alt="Adway" @click="$router.push({name: 'Main'})" >
          </div>

          <div class="meni-container" v-if="user.role == 'advertiser' || user.role == 'manager'" :class="{'active__menu': menu}">
                <router-link id='dashboard' to="/advertiser/dashboard" @click.native="dashboardClicked(false)"><dashboard/><span>Dashboard</span></router-link>
                <router-link id="campaign" to="/advertiser/campaign" @click.native="toggleMenu(false)"><create-campaign/>Create Campaign</router-link>
                <router-link id="finance" to="/advertiser/finance" @click.native="toggleMenu(false)"><finance/>Finance</router-link>
                <router-link id="account" to="/advertiser/account" @click.native="toggleMenu(false)"><account/>Account</router-link>
                <router-link id="contactus" to="/advertiser/contactus" @click.native="toggleMenu(false)"><contact-us/>Contact Us</router-link>
                <router-link id="aboutus" to="/advertiser/aboutus" @click.native="toggleMenu(false)"><about-us/>About Us</router-link>
                <a @click="logout"><svg/>Log Out</a>
          </div>

          <div class="meni-container" v-if="user.role == 'driver'" :class="{'active__menu': menu}">
              <router-link id="account" to="/driver/account" @click.native="toggleMenu(false)"><account/>Account</router-link>
              <router-link id="finance" to="/driver/finance" @click.native="toggleMenu(false)"><finance/>Finance</router-link>
              <a @click="logout"><svg/>Log Out</a>
          </div>

          <div class="meni-container" v-if="user.role == 'admin'" :class="{'active__menu': menu}">
              <router-link id="dashboard" to="/admin/dashboard" @click.native="toggleMenu(false)"><dashboard/>Dashboard</router-link>
              <router-link id="dashboard" to="/admin/createcampaign" @click.native="toggleMenu(false)"><create-campaign/>Create Campaign</router-link>
              <router-link id="drivers" to="/admin/drivers" @click.native="toggleMenu(false)"><drivers/>Drivers</router-link>
              <router-link id="devices" to="/admin/devices" @click.native="toggleMenu(false)"><devices-icon/>Devices</router-link>
              <router-link id="advertisers" to="/admin/advertisers" @click.native="toggleMenu(false)"><advertisers/>Advertisers</router-link>
              <router-link id="campaigns" to="/admin/campaigns" @click.native="toggleMenu(false)"><campaigns/>Campaigns</router-link>
              <router-link id="reports" to="/admin/reports" @click.native="toggleMenu(false)"><file-icon/>Reports</router-link>
              <a @click="logout"><svg/>Log Out</a>
          </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Dashboard from '@svg/Dashboard'
import Account from '@svg/Account'
import AboutUs from '@svg/AboutUs'
import ContactUs from '@svg/ContactUs'
import Finance from '@svg/Finance'
import CreateCampaign from '@svg/CreateCampaign'
import Advertisers from '@svg/Advertisers'
import Campaigns from '@svg/Campaigns'
import Drivers from '@svg/Drivers'
import FileIcon from '@svg/FileIcon'
import store from '@store'
import toast from '@utils/toast'
import $ from 'jquery'
import DevicesIcon from '@/components/menu/iconsMenu/DevicesIcon.vue'

export default {
  name: 'SideMenu',
  components: {
    Dashboard,
    Account,
    AboutUs,
    ContactUs,
    Finance,
    CreateCampaign,
    Advertisers,
    Campaigns,
    Drivers,
    FileIcon,
    DevicesIcon
  },
  computed: {
    ...mapGetters({
        user: 'getUser',
        activeLink: 'getActiveLink',
        menu: 'getMenu',
        popup: 'getPopup',
    })
  },
  methods: {
    logout () {
      this.request('/logout', 'POST', {}).then((response) => {
        if (response.code === 0) {
          store.dispatch('logout')
          toast.logout()
          this.toggleMenu(false)
          this.$router.push({name: 'Login'})
        } else {
          toast.errorMessage(response.message)
          this.$router.push({name: 'Login'})
        }
      }).catch((error) => {
      })
    },
    dashboardClicked() {
      if(this.popup === true){
        store.commit('setPopup', false)
      }
      this.toggleMenu(false)
    },
    toggleMenu(value=null) {
      if(this.isMobile()){
        store.commit('setMenu', value || !this.menu)
      }
    }
  },
}
</script>
